import { AspObject, ObjectType } from '../AspObject';
import { ObjectsMenuService } from '../../menu-bars/objects-menu.service';
import { AppInjector } from '../../common/inject';
import { IMapMngr, IMapClickHandler } from '../interfaces';

const MAX_OBJECTS_IN_MENU = 10;

export class MapTool {

  protected mapClickHandler: IMapClickHandler = null;
  protected allowSingleObjectClick: boolean = false;

  constructor(public mapMngr: IMapMngr, protected mapEvents: any[]) {
  }

  public setMapClickHandler(handler: IMapClickHandler, cursor?: string, allowSingleObjectClick?: boolean) {
    if (cursor && cursor.length > 0)
      this.mapMngr.setCursor(cursor);
    else
      this.mapMngr.restoreCursor();
    this.mapClickHandler = handler;
    this.allowSingleObjectClick = allowSingleObjectClick;
  }

  handleMapEvent(event): boolean {
    if (!this.mapEvents.includes(event.eventType))
      return false;
    switch (event.eventType) {
      case NeWMI.Map.Enums.EMapEvents.MouseDown:
        return this.handleMouseDown(event);
      case NeWMI.Map.Enums.EMapEvents.MouseUp:
        return this.handleMouseUp(event);
      case NeWMI.Map.Enums.EMapEvents.MouseDblClick:
        return this.handleDblClick(event);
      default:
        return false;
    }
  }

  handleMouseDown(event): boolean {
    if (event.button == 0) {
      // left mouse button
      let objects = this.sortObjects(this.mapMngr.objectsAtLocation(event.mapPoint, true));
      if (objects) {
        if (objects.length > 1) {
          // AppInjector.get(ObjectsMenuService).showObjectsMenu(objects, event, this.mapMngr, this.mapClickHandler);
          // AppInjector.get(ObjectsMenuService).showContextMenu(objects, event, this.mapMngr);
          return true;
        }
        else if (objects.length == 1 && this.mapClickHandler && this.allowSingleObjectClick) {
          this.mapClickHandler.onObjectsClicked(objects);
          return true;
        }
      }
    }
    return false;
  }

  handleMouseUp(event): boolean {
    return false;
  }

  handleDblClick(event): boolean {
    return false;
  }

  private static readonly objectTypes = Object.values(ObjectType);

  protected sortObjects(objects: AspObject[]): AspObject[] {
    if (!objects)
      return null;
    let sortedObjs = new Array<any>(MapTool.objectTypes.length);
    for (let i = 0; i < sortedObjs.length; i++)
      sortedObjs[i] = new Array<any>();

    for(let obj of objects) {
      let objTypeIndex = MapTool.objectTypes.indexOf(obj.objectType);
      sortedObjs[objTypeIndex].push(obj);
    }

    // if tracks are picked, no plots should be picked
    if (sortedObjs[MapTool.objectTypes.indexOf(ObjectType.Track)].length > 0) {
      sortedObjs[MapTool.objectTypes.indexOf(ObjectType.Plot)].length = 0;
    }

    let result = new Array<any>();
    for (let i = 0; i < sortedObjs.length; i++) {
      for (let j = 0; j < sortedObjs[i].length; j++) {
        result.push(sortedObjs[i][j]);
        if (result.length == MAX_OBJECTS_IN_MENU)
          break;
      }
      if (result.length == MAX_OBJECTS_IN_MENU)
        break;
    }
    return result;
  }

}
